import { render, staticRenderFns } from "./AmenabilityTooltip.vue?vue&type=template&id=28dc6ed0"
import script from "./AmenabilityTooltip.vue?vue&type=script&lang=js"
export * from "./AmenabilityTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports